import * as React from 'react';
import { connect } from 'react-redux';
import '../css/SuperUserPageView.css';
import { TooltipCont } from '../../../infrastructure/tooltips';
import { getScrollbarWidth } from '../../../lib/helpers';
import { IBlank } from '../../../infrastructure/interfaces'
import { getBlanks, toggleBlankPublish, createBlank, updateBlank} from '../../../actions/actions'
import HeaderBar from '../../HeaderBar/HeaderBar';
import BlankCreatorModal from '../../Modals/BlankCreatorModal/BlankCreatorModal'
import { contentImagesRelativePath } from '../../../constants';

export interface IManageFullPageCatalogImagesProps {
  blanks?: IBlank[];
  toggleBlankPublish(blank: IBlank): void;
  createBlank(blankName: string, url: string, formData: FormData): void;
  updateBlank(blank: IBlank, formData?: FormData): void;
  getBlanks(): void;
  onCreate(): void;
}

export interface IManageFullPageCatalogImagesState {
  selectedBlank?: IBlank;
  showEditModal: boolean;
}

const mapStateToProps = (state: any) => {
  return {
    blanks: state.blankList,
  };
};

const mapDispatchToProps = (dispatch: any): any => {
  return {
    getBlanks: () => {
      dispatch(getBlanks());
    },
    toggleBlankPublish: (blank: IBlank) => {
      dispatch(toggleBlankPublish(blank));
    },
    createBlank: (blankName: string, url: string, formData: FormData) => {
      dispatch(createBlank(blankName, url, formData));
    },
    updateBlank: (blank: IBlank, formData?: FormData) => {
      dispatch(updateBlank(blank, formData));
    }
  };
};


@(connect(mapStateToProps, mapDispatchToProps) as any)
export default class ManageFullPageCatalogImagesTable extends React.Component<IManageFullPageCatalogImagesProps, IManageFullPageCatalogImagesState> {
  tableRow: HTMLElement;
  constructor(props: IManageFullPageCatalogImagesProps) {
    super(props);
    this.state = {
      selectedBlank: undefined,
      showEditModal: false
    };

    // Bind methods
    this.closeModals = this.closeModals.bind(this)
    this.createBlank = this.createBlank.bind(this)
  }

  componentDidMount() {
    this.props.getBlanks();
  }

  onEditBlank = (blank: IBlank) => {
    this.setState({
        selectedBlank: blank,
        showEditModal: true
    });
  }


  onCreateBlank() {
    this.setState({
        selectedBlank: undefined,
        showEditModal: true,
    });
  }

  ontoggleBlankPublish(blank: IBlank) {
    if( blank ) {
      this.toggleBlankPublish(blank);
    }
  }

  toggleBlankPublish(blank: IBlank) {
    this.props.toggleBlankPublish(blank)
  }

  createBlank(blankName: string, url: string, formData: FormData) {
    this.props.createBlank(blankName, url, formData)
  }

  updateBlank(blank: IBlank, formData?: FormData) {
    this.props.updateBlank(blank, formData);
  }

  closeModals() {
    this.setState({
      selectedBlank: undefined,
      showEditModal: false
    });
  }

  render() {
    const {
      blanks,
    } = this.props;
    var nonNullFullPageCatalogImages = blanks ? blanks : [];

    return (
      <div className="root-container">
        <HeaderBar />
        <div className="inner-su-container">
          <div className="manage-items-row-offsetRight">

            <div className="in-row-text-container">
              Manage Full Page Catalog Images
            </div>
            <div className="in-row-button-container">
              <button
                className="btn primary-green large"
                onClick={() => this.onCreateBlank()}
                title={TooltipCont.CREATE_PRODUCT}
              >
                Upload New Full-page Image
              </button>
            </div>
          </div>
          <table className="table-scrollableSU documents-table">
            <thead style={{ paddingRight: getScrollbarWidth() }}>
              <tr>
                <th>Image</th>
                <th>Title</th>
                <th>URL</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody className="document-table-body">
              {nonNullFullPageCatalogImages.sort((a: IBlank, b: IBlank) => (a.id < b.id) ? 1 : -1).map((b: IBlank) =>
                <tr key={b.id} ref={tr => this.tableRow = tr!}>
                  <td>
                    <img className="inlineImagesTableImage" src={contentImagesRelativePath + b.src} />
                  </td>
                  <td>{(b.title != null) ? b.title : ''}</td>
                  <td>{(b.url != null) ? b.url : ''}</td>
                  <td>
                    <div className="button-wrapper">
                      <button
                        className="btn primary-blue"
                        onClick={() => this.onEditBlank(b)}
                        title={TooltipCont.EDIT}
                        disabled={false}
                      >
                        Edit
                      </button>

                      <button
                        className="btn primary-blue"
                        onClick={() => this.ontoggleBlankPublish(b)}
                        title={TooltipCont.PUBLISH}
                        disabled={false}
                      >
                        {b.published ? "Unpublish" : "Publish"}
                      </button>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        <BlankCreatorModal
          blank={this.state.selectedBlank}
          show={this.state.showEditModal}
          onClose={this.closeModals}
          updateBlank={ (blank: IBlank, formData?: FormData) => {
            this.updateBlank(blank, formData)
            this.closeModals();
          }}
          createBlank={ (blankName: string, url: string, formData: FormData) => {
            this.createBlank(blankName, url, formData);
            this.closeModals();
          }}
        />
      </div>);
  }
}



// WEBPACK FOOTER //
// ./src/components/SuperUser/components/ManageFullPageCatalogImages.tsx